import { URMRole, URMRoles } from '@/models/dto/userRoleManagement'
import type { ContactCurrentUserPermissions } from '@/models/dto/ContactGroup'
import quotes from '@/services/quotes'
import reservationDetail from '@/services/reservationDetail'
import { AddContactRequestDTO } from '@/models/dto/contact/AddContactRequestDTO'
import { UpdateContactRequestDTO } from '@/models/dto/contact/UpdateContactRequestDTO'

export enum ContactType {
  Quote = 'quote',
  Reservation = 'reservation',
}
export enum ContactAction {
  Add = 'add',
  Update = 'update',
  Remove = 'remove',
}
type AddContactFunction = (entityId: number, payload: AddContactRequestDTO) => Promise<any>
type UpdateContactFunction = (entityId: number, externalUserId: string, payload: UpdateContactRequestDTO) => Promise<any>
type RemoveContactFunction = (entityId: number, externalUserId: string) => Promise<any>
export function getContactServiceCall(contactType: ContactType, contactAction: ContactAction.Add): AddContactFunction
export function getContactServiceCall(contactType: ContactType, contactAction: ContactAction.Update): UpdateContactFunction
export function getContactServiceCall(contactType: ContactType, contactAction: ContactAction.Remove): RemoveContactFunction
export function getContactServiceCall(contactType: ContactType, contactAction: ContactAction): AddContactFunction | UpdateContactFunction | RemoveContactFunction {
  const map = {
    [ContactType.Quote]: {
      [ContactAction.Add]: quotes.addContact,
      [ContactAction.Update]: quotes.updateContact,
      [ContactAction.Remove]: quotes.deleteContact,
    },
    [ContactType.Reservation]: {
      [ContactAction.Add]: reservationDetail.addContact,
      [ContactAction.Update]: reservationDetail.updateContact,
      [ContactAction.Remove]: reservationDetail.deleteContact,
    },
  }
  const serviceFunction = map[contactType]?.[contactAction]
  if (!serviceFunction) {
    throw new Error(`Invalid contact type: ${contactType} or action: ${contactAction}`)
  }
  return serviceFunction
}

export const getDisabledUserRoles = (perms?: ContactCurrentUserPermissions): URMRole[] => {
  if (!perms) return []
  const disabled: URMRole[] = []
  if (!perms.canModifyAuthorizedUserRole) disabled.push(URMRoles.TripAuthorizedUser)
  if (!perms.canModifyViewOnlyUserRole) disabled.push(URMRoles.TripViewOnly)
  if (!perms.canModifyIsEditor) disabled.push(URMRoles.TripEditor)
  if (!perms.canModifyIsTripContact) disabled.push(URMRoles.TripContact)
  return disabled
}
